import { ADMIN, SUPER_HOST, USER_HOST, USER } from '../components/Common/constants';

/**
 * Priority order for roles (highest to lowest)
 */
const ROLE_PRIORITY = [
  'role.suadmin', // Super Admin
  ADMIN,          // role.admin
  SUPER_HOST,     // role.super.host
  USER_HOST,      // role.user.host
  USER            // role.user
];

/**
 * Returns the primary role from an array of authorities based on predefined priority.
 * @param {string[]} authorities - Array of role strings
 * @returns {string|null} The highest priority role found, or the first role if no priority match.
 */
export const getPrimaryRole = (authorities) => {
  if (!authorities || !Array.isArray(authorities) || authorities.length === 0) {
    return null;
  }

  for (const role of ROLE_PRIORITY) {
    if (authorities.includes(role)) {
      return role;
    }
  }

  // Fallback to the first role if none of the priority roles are found
  return authorities[0];
};
